/**
 * Shared marker for subagent runs that no longer have a live gateway job
 * (typical after crash/restart). Kept as a stable prefix for UI detection.
 */
export const SUBAGENT_DEFUNCT_ERROR = "defunct: run lost (no live gateway job)";

export function isSubagentDefunctError(error?: string | null): boolean {
  return typeof error === "string" && error.startsWith("defunct:");
}

export function isSubagentDefunctOutcome(
  outcome?: {
    status?: string;
    error?: string;
  } | null,
): boolean {
  if (!outcome) {
    return false;
  }
  if (outcome.status === "timeout" && isSubagentDefunctError(outcome.error)) {
    return true;
  }
  return isSubagentDefunctError(outcome.error);
}
